import React from 'react'

const GetInvolvedBody = ({ className }) => {
    return (
      <div className={className}>
      </div>
    )
}

export default GetInvolvedBody



// WEBPACK FOOTER //
// ./src/components/Home/GetInvolvedBody.js